import { readStorageValue, removeStorageValue, saveStorageValue } from 'hooks/use-storage/use-storage.utils';
import { Flags } from './flags.types';

export const FF_OVERRIDES_KEY = 'ff-overrides';
type OverridedFlags = { [key: keyof Flags]: boolean };

export const getStoredFlagOverrides = () => {
  return readStorageValue({
    storageKey: FF_OVERRIDES_KEY,
    fallbackValue: {},
    validate: (value): value is OverridedFlags => {
      if (!value || typeof value !== 'object' || Array.isArray(value)) {
        return false;
      }

      return Object.values(value).every((item) => typeof item === 'boolean');
    },
  });
};

export const setStoredFlagsOverrides = (payload: OverridedFlags) => {
  saveStorageValue({ storageKey: FF_OVERRIDES_KEY, value: payload });
};

export const removeStoredFlagsOverrides = () => {
  removeStorageValue(FF_OVERRIDES_KEY);
};
